import * as React from 'react';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {AddressFieldItem} from './address-field-item';
import {dropdownFieldNames} from './consts';

type Props = {
    name: string;
    control: Control;
    watch: Watch;
    fields: Array<any>;
};

export const AddressFieldList = (props: Props) => {
    return (
        <>
            {props.fields.map((subfield) => {
                if (!subfield.isEnabled) {
                    return null;
                }

                const isRequired = props.watch(`${props.name}.isRequired`);
                const isDropdown = dropdownFieldNames.includes(subfield.name);

                return (
                    <AddressFieldItem
                        key={subfield.name}
                        name={props.name}
                        control={props.control}
                        watch={props.watch}
                        isRequired={isRequired}
                        isDropdown={isDropdown}
                        subfieldKey={subfield.name}
                    />
                );
            })}
        </>
    );
};
